import React, { Component } from 'react';
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import PropTypes from "prop-types";
import {updateData} from '../../routers/data'
import {hideMessage} from '../../routers/messages'

import Toggle from 'material-ui/Toggle';

import FirstHeader from '../components/firstHeader'
import Header from '../components/header'
import SecondHeader from '../components/secondHeader'
import DialogError from '../components/dialogError'
import Footer from '../components/footer'

import FormBooking from './components/formBooking'
import FormPassangers from './components/formPassangers'
import FormVehicle from './components/formVehicle'
import FormTowing from './components/formTowing'
import {FielsFilter} from './functions'


class routeData extends Component {
  constructor(props) {
    super(props);
    this.onClickNext.bind(this)
  }

  static contextTypes = {
    router: PropTypes.object
  }

  
  isMobileDevice = () => {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
  }

  handleClose = () => {
    this.props.hideMessage()
  };

  UpdateObjects(object, stateValues){
    let change = false
    let valuesDefault = {}
    for (let i = 0; i < object.length; i++){
      let {name, count, defaultValues} = object[i]
      for (let k = 1; k <= stateValues[count]; k++){
        let key = (name + k).toLowerCase()
        let data = this.props.data[key]
        if (data === undefined){
          change = true
          valuesDefault[key] = {...defaultValues}
        }
      }
    }
    return ({change: change, valuesDefault: valuesDefault})
  }

  componentWillMount() {
    const definedData = this.props.settings.definedData
    const keys = Object.keys(definedData)

    let data = {}
    let change = false
    for (let k in keys){
      let object = definedData[keys[k]]
      let result = this.UpdateObjects(object, this.props.values)
      if (result.change){
        change = true
        data = {...data, ...result.valuesDefault}
      }
    }

    if (change){
      this.props.updateData({...this.props.data, ...data})
    }
  }

  onClickIsPassanger1 = () => {
    const key = 'isPassager1'
    const dataValues = this.props.values
    const {isPassager1} = dataValues
    const {name, surname, secondSurname, typeDocument, numberDocument} = this.props.data['contact']
    const adult1 = this.props.data['adult1']
    if (!isPassager1){
      this.props.updateData({values: {...dataValues, [key]: !isPassager1},
                             adult1: {...adult1, 'name': name, 'surname': surname,
        'secondSurname': secondSurname || ' ', 'typeDocument': typeDocument, 'numberDocument': numberDocument}})
    } else {
      this.props.updateData({values: {...dataValues, [key]: !isPassager1}})
    }
  }

  onClickNext = (evt) => {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].dataresume

    const { passangers, vehicles } = this.props.settings.definedData

    let result = {}
    let filter = undefined
    const arrayBooking = ['name', 'surname', 'secondSurname', 'numberDocument', 'prefix', 'phone', 'email', 'repeatEmail', 'postalcode']
    arrayBooking.forEach((name) => {
      let contact = this.props.data.contact
      filter = FielsFilter(langPlace, name, contact[name], contact)

      if (filter.isError){
        let id = 'contact' + name
        result[id] = filter
      }
    })


    let arrayPassangers = []

    passangers.forEach(({name, count}) => {
      switch (name) {
        case 'baby':
          arrayPassangers = ['name', 'surname', 'secondSurname', 'nationality', 'numberDocument', 'birthDate', 'gender']
          break;
        default:
          arrayPassangers = ['locationGone', 'locationReturn', 'name', 'surname', 'secondSurname', 'nationality', 'numberDocument', 'birthDate', 'gender']
      }

      for (let i = 1; i <= this.props.values[count]; i++) {
        for (let k = 0; k < arrayPassangers.length; k++) {
          let field = arrayPassangers[k]
          let passanger = this.props.data[name + i]

          if (passanger === undefined){
            filter = FielsFilter(langPlace, field, undefined)
          } else {
            filter = FielsFilter(langPlace, field, passanger[field])
          }

          if (filter.isError){
            let id = name + i + field
            result[id] = filter
          }
        }
      }
    })

    let arrayVehicles = []
    vehicles.forEach(({name, count}) => {
      switch (name) {
        case 'car':
          arrayVehicles = ['brand', 'model', 'licensePlate', 'exported']
          break;
        case 'motorcycle':
          arrayVehicles = ['brand', 'model', 'licensePlate', 'displacement']
          break;
        case 'towing':
          arrayVehicles = ['brand', 'model', 'licensePlate', 'towing']
          break;
        default:
          arrayVehicles = ['brand', 'model', 'licensePlate', 'length']
      }

      for (let i = 1; i <= this.props.values[count]; i++) {
        for (let k = 0; k < arrayVehicles.length; k++) {
          let field = arrayVehicles[k]
          let vehicle = this.props.data[name + i]
          if (vehicle === undefined){
            filter = FielsFilter(langPlace, field, undefined)
          } else {
            filter = FielsFilter(langPlace, field, vehicle[field])
          }

          if (filter.isError){
            let id = name + i + field
            result[id] = filter
          }
        }
      }
    })

    const keys = Object.keys(result)

    if (keys.length > 0){
      const node = document.getElementById(keys[0])
      // TODO: hotfix -> scroll to 'node' in order to get user's attention to the invalid field
      this.props.updateData({errors: {...result}})
    } else {
      window.scrollTo(0, 0)
      this.context.router.history.push(`/${langUrl}/resume`)
    }
  }

  onClickPrevious = () =>{
    const lang = this.context.router.route.location.pathname.split('/')[1]
    this.context.router.history.push(`/${lang}/search`)
    document.querySelector('.second-header').classList.remove('js-is-sticky')
    window.scrollTo(window.scrollX, 0)
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].dataresume


    const {passangers, vehicles} = this.props.settings.definedData
    const {isPassager1} = this.props.values

    const {nAdults, nTeens, nKids, nBabies} = this.props.values
    const {nCars, nVans, nMotorcycles, nTowing} = this.props.values
    const nPass = nAdults + nTeens + nKids + nBabies

    let isMobile;
    if (this.isMobileDevice() === true) {
      isMobile = <SecondHeader step={1} mobile={true} />;
    }
    else {
      isMobile = <SecondHeader step={1} mobile={false}/>
    }

    if (nPass){
      return (
        <div>
          <FirstHeader />
          <Header />
          <div className='container-fluid route-data'>
            <DialogError messages={this.props.messages} handleClose={this.handleClose} />
              {isMobile}
            <div className="second-header-placeholder"></div>
            <div className="row">
              <div className="container">
                <div className="flex-row ">
                    <div className='col-md-12 col-sm-12 col-xs-12'>
                      <div className='row'>

                        <form>
                          <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                              <p className='section-title'>{langPlace.contacttitle}</p>
                            </div>
                          </div>

                          <div className='row section-middle-paragraph'>
                              <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                                {langPlace.contacttext}
                              </div>
                          </div>

                          <div className='row'>
                            <FormBooking/>
                          </div>

                          <div className='separating-line margin-top-50'><hr/></div>

                          <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                              <p className='section-title'>{langPlace.passengerstitle}</p>
                            </div>
                          </div>

                          <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12 checkboxButton'>
                              <div className="checkbox-container">
                                <Toggle label={langPlace.contactequal}
                                    defaultValue={(isPassager1)? true: false} labelPosition='right'onClick={this.onClickIsPassanger1}/>
                              </div>
                            </div>
                          </div>
                          <div className='row'>
                            {passangers.map(({name, title, count}, index) =>
                              <div key={index}>
                                {[...Array(this.props.values[count])].map((key, index) =>

                                  (<FormPassangers key={index} index={index + 1} name={name} title={title}/>)
                                )}
                              </div>
                            )}
                          </div>

                          {(nCars + nVans + nMotorcycles + nTowing > 0)?
                            <div>
                              <div className='separating-line margin-top-50'><hr/></div>
                              <div className='row'>
                                <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                                  <p className='section-title no-padding'>{this.vehicletitle}</p>
                                </div>
                                {vehicles.map(({name, title, count}, index) =>
                                  <div key={index}>
                                    {[...Array(this.props.values[count])].map((key, index) =>
                                      {switch (name) {
                                        case 'towing':
                                          return(<FormTowing key={index} index={index + 1} name={name} title={title}/>)
                                        default:
                                          return(<FormVehicle key={index} index={index + 1} name={name} title={title}/>)
                                      }}
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          :''}
                        </form>
                        <div className='separating-line margin-top-50'><hr/></div>

                        <div className='col-lg-4 col-md-4 col-sm-5 col-xs-5 no-padding'>
                          <div className='previous-button' onClick={this.onClickPrevious}>
                            <i className="fa fa-angle-left" aria-hidden="true"></i>{langPlace.previous}
                          </div>
                        </div>
                        <div className='col-lg-4 col-md-8 col-sm-7 col-xs-2'/>
                        <div className='col-lg-4 col-md-4 col-sm-5 col-xs-5 no-padding'>
                          <div className='general-button button-next' onClick={this.onClickNext}>
                            {langPlace.confirm}<i className="fa fa-angle-right" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      )
    } else {
      return (<Redirect to={`/${langUrl}`} />);
    }
  }
}

export default connect(
  (state) => ({settings: state.settings, values: state.data.values, data: state.data, errors: state.data.errors, messages: state.messages}),
  {updateData, hideMessage}
)(routeData)



// WEBPACK FOOTER //
// ./src/shared/routes/routeData/index.js